<template>
    <div class="d-flex justify-content-around h-100 w-100 mobile-nav-item-container">
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'Welcome', params: { uuid: id } }"
        >
            <div
                :class="[isActive && 'active', isExactActive && 'exact-active']"
                class="mobile-nav-item"
                @click="navigate"
            >
                <div class="mobile-nav-icon">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20 11V9a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h4m4 5v-4a2 2 0 1 1 4 0v4m-4-2h4m3-4v6"
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </svg>
                </div>
                <div>{{ 'Create' | trans }}</div>
            </div>
        </router-link>
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'StyleCanvas', params: { uuid: id } }"
        >
            <div
                :class="[isActive && 'active', isExactActive && 'exact-active']"
                class="mobile-nav-item d-flex d-inline-flex align-items-center h-100 gap-50"
                @click="navigate"
            >
                <div class="mobile-nav-icon"><i class="far fa-style lh-inherit fa-2x"></i></div>
                <div>{{ 'Styles' | trans }}</div>
            </div>
        </router-link>
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'PromptEditorCanvas', params: { uuid: id } }"
        >
            <div
                :class="[isActive && 'active', isExactActive && 'exact-active']"
                class="mobile-nav-item d-flex d-inline-flex align-items-center h-100 gap-50"
                @click="navigate"
            >
                <div class="mobile-nav-icon">
                    <svg width="25" height="21" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            stroke="white"
                            d="M1.33325 0.666626L4.66659 3.99996L1.33325 7.33329M6.66659 7.33329H10.6666"
                            stroke-width="1.33333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div>{{ 'Prompt' | trans }}</div>
            </div>
        </router-link>
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'JobCanvas', params: { uuid: id } }"
        >
            <div
                :class="[isActive && 'active', isExactActive && 'exact-active']"
                class="mobile-nav-item d-flex d-inline-flex align-items-center h-100 gap-50"
                @click="navigate"
            >
                <div class="mobile-nav-icon"><i class="far fa-image lh-inherit fa-2x"></i></div>
                <div>{{ 'Creations' | trans }}</div>
            </div>
        </router-link>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';

export default {
    name: 'MobileNavbar',
    props: {},
    components: {},
    mixins: [store, currentJob],
    data() {
        return {};
    },
    mounted: function () {},
    created: function () {},
    methods: {},
    computed: {},
};
</script>
<style lang="scss">
.mobile-nav-item-container {
    gap: 0px;
    align-items: stretch;
    justify-content: center;
}

.mobile-nav-item {
    height: 100%;
    align-items: center;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: white;
    justify-content: center;

    &.active {
        background: #333333;
    }

    .mobile-nav-icon {
        height: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>
